import tables from "./tables.js";

export default {
  13: {
    name: 'SYSTEM PARAMETERS',
    0: { name: 'Free System Blocks' },
    1: { name: 'Free Disk Blocks' },
    2: { name: 'Master Tune', signed: true },
    3: { name: 'Global Bend Range' },
    4: { name: 'Touch Sensitivity' },
    5: { name: 'Mod Pedal Mode' },
    6: { name: 'Sustain Pedal Mode' },
    7: { name: 'Aux Pedal Mode' },
    8: { name: 'Autoloop Switch' },
  },
  12: {
    name: 'MIDI PARAMETERS',
    0: { name: 'Base Channel' },
    1: { name: 'Midi Transmit Mode' },
    2: { name: 'Base Channel Pressure Mode' },
    3: { name: 'Midi In Mode' },
    4: { name: 'Midi Controllers Enable' },
    5: { name: 'Midi SYSEX Enable' },
    6: { name: 'Midi Program Change Enable' },
    7: { name: 'Midi Song Position Enable' },
    8: { name: 'Midi XCTRL Value' },
  },
  10: {
    name: 'INSTRUMENT PARAMETERS',
    0: { name: 'Patch' },
    1: { name: 'Key Down Layers' },
    2: { name: 'Key Up Layers' },
    3: { name: 'Midi Channel' },
    4: { name: 'Midi Program' },
    5: { name: 'Pressure Mode' },
    7: { name: 'Instrument Size' },
    6: { name: 'Send Keys To' },
    10: { name: 'Range Low Key' },
    11: { name: 'Range High Key' },
    12: { name: 'Transpose Amount-Octave' },
    13: { name: 'Transpose Amount-Semitone' },
  },
  9: {
    name: 'LAYER PARAMETERS',
    0: { name: 'Glide Mode' },
    1: { name: 'Glide Time' },
    2: { name: 'Legato Layer' },
    3: { name: 'Velocity Low' },
    10: { name: 'Velocity High' },
    4: { name: 'Pitch Table' },
  },
  8: {
    name: 'WAVESAMPLE PARAMETERS',
    0: { name: 'Loop Mode', table: tables[8] },
    6: { name: 'Loop Mod Type' },
    7: { name: 'Loop Mod Source', table: tables[2] },
    8: { name: 'Loop Mod Amount 1' },
    9: { name: 'Loop Mod Amount 2', table: tables[7] },
    21: { name: 'Wavedata Start' },
    22: { name: 'Wavedata End' },
    23: { name: 'Loop Start' },
    24: { name: 'Loop End' },
    10: { name: 'Loop End Fractional' },
    11: { name: 'Key Range Low' },
    12: { name: 'Key Range High' },
    25: { name: 'Loop Position' },
    13: { name: 'Sample Rate' },
  },
  1: {
    name: 'ENVELOPE 1 PARAMETERS',
    0: { name: 'Envelope Type', table: tables[3] },
    1: { name: 'Level 0 Hard' },
    2: { name: 'Level 0 Soft' },
    11: { name: 'Level 1 Hard' },
    15: { name: 'Level 1 Soft' },
    12: { name: 'Level 2 Hard' },
    16: { name: 'Level 2 Soft' },
    13: { name: 'Level 3 Hard' },
    17: { name: 'Level 3 Soft' },
    14: { name: 'Level 4 Hard' },
    18: { name: 'Level 4 Soft' },
    3: { name: 'Time 1' },
    19: { name: 'Time 2' },
    20: { name: 'Time 3' },
    21: { name: 'Time 4' },
    22: { name: 'Time 5' },
    4: { name: '2nd Release Time' },
    23: { name: '2nd Release Level', signed: true },
    5: { name: 'Attack Time Velocity' },
    6: { name: 'Keyboard Scaling' },
    7: { name: 'Soft Velocity On/Off' },
    8: { name: 'Envelope Mode' },
  },
  2: {
    name: 'ENVELOPE 2 PARAMETERS',
    0: { name: 'Envelope Type', table: tables[3] },
    1: { name: 'Level 0 Hard' },
    2: { name: 'Level 0 Soft' },
    11: { name: 'Level 1 Hard' },
    15: { name: 'Level 1 Soft' },
    12: { name: 'Level 2 Hard' },
    16: { name: 'Level 2 Soft' },
    13: { name: 'Level 3 Hard' },
    17: { name: 'Level 3 Soft' },
    14: { name: 'Level 4 Hard' },
    18: { name: 'Level 4 Soft' },
    3: { name: 'Time 1' },
    19: { name: 'Time 2' },
    20: { name: 'Time 3' },
    21: { name: 'Time 4' },
    22: { name: 'Time 5' },
    4: { name: '2nd Release Time' },
    23: { name: '2nd Release Level', signed: true },
    5: { name: 'Attack Time Velocity' },
    6: { name: 'Keyboard Scaling' },
    7: { name: 'Soft Velocity On/Off' },
    8: { name: 'Envelope Mode' },
  },
  3: {
    name: 'ENVELOPE 3 PARAMETERS',
    0: { name: 'Envelope Type', table: tables[3] },
    1: { name: 'Level 0 Hard' },
    2: { name: 'Level 0 Soft' },
    11: { name: 'Level 1 Hard' },
    15: { name: 'Level 1 Soft' },
    12: { name: 'Level 2 Hard' },
    16: { name: 'Level 2 Soft' },
    13: { name: 'Level 3 Hard' },
    17: { name: 'Level 3 Soft' },
    14: { name: 'Level 4 Hard' },
    18: { name: 'Level 4 Soft' },
    3: { name: 'Time 1' },
    19: { name: 'Time 2' },
    20: { name: 'Time 3' },
    21: { name: 'Time 4' },
    22: { name: 'Time 5' },
    4: { name: '2nd Release Time' },
    23: { name: '2nd Release Level', signed: true },
    5: { name: 'Attack Time Velocity' },
    6: { name: 'Keyboard Scaling' },
    7: { name: 'Soft Velocity On/Off' },
    8: { name: 'Envelope Mode' },
  },
  4: {
    name: 'PITCH PARAMETERS',
    1: { name: 'Root Key' },
    10: { name: 'Fine Tune', signed: true },
    2: { name: 'LFO Amount' },
    3: { name: 'Envelope 1 Amount', signed: true },
    5: { name: 'Random Frequency' },
    12: { name: 'Random Amount', signed: true },
    6: { name: 'Bend Range' },
    7: { name: 'Modulation Source', table: tables[2] },
    11: { name: 'Modulation Amount', signed: true },
  },
  5: {
    name: 'FILTER PARAMETERS',
    0: { name: 'Filter Mode', table: tables[4] },
    1: { name: 'Filter 1 Cutoff' },
    11: { name: 'Filter 2 Cutoff' },
    2: { name: 'Filter 1 Envelope 2 Amount', signed: true },
    12: { name: 'Filter 2 Envelope 2 Amount', signed: true },
    3: { name: 'Filter 1 Keyboard Amount', signed: true },
    13: { name: 'Filter 2 Keyboard Amount', signed: true },
    7: { name: 'Filter 1 Modulation Source', table: tables[2] },
    14: { name: 'Filter 1 Modulation Amount', signed: true },
    8: { name: 'Filter 2 Modulation Source', table: tables[2] },
    15: { name: 'Filter 2 Modulation Amount', signed: true },
  },
  6: {
    name: 'VOLUME PARAMETERS',
    1: { name: 'Wavesample Volume' },
    2: { name: 'Pan', table: tables[5] },
    3: { name: 'Modulation A' },
    11: { name: 'Modulation B' },
    4: { name: 'Modulation C' },
    12: { name: 'Modulation D' },
    7: { name: 'Modulation Source', table: tables[2] },
    10: { name: 'Modulation Amount' },
  },
  7: {
    name: 'LFO PARAMETERS',
    1: { name: 'LFO Wave', table: tables[6] },
    2: { name: 'LFO Speed' },
    3: { name: 'LFO Depth' },
    4: { name: 'LFO Delay' },
    5: { name: 'LFO Mode' },
    7: { name: 'LFO Modulation Source', table: tables[2] },
  },
  14: {
    name: 'EDIT PARAMETERS',
    0: { name: 'Edit Instrument' },
    1: { name: 'Edit Layer' },
    2: { name: 'Edit Wavesample' },
  },
};
